import { rewardsOverviewText } from "../../settings/Constants";
import Banner from "./Banner";
import Card from "./Card";
import Line from "./Line";
import Footer from "./Footer";
import PiggyBank from "../UI/Icons/PiggyBank";
import Hotel from "../UI/Icons/Hotel";
import MapMarker from "../UI/Icons/MapMarker";
import styled, { css } from "styled-components";
import { rem } from "polished";
import PropTypes from "prop-types";

const CardContainer = styled.div`
  margin: ${rem("40px")} ${rem("0px")} ${rem("16px")};
  display: flex;
  justify-content: space-between;

  > div svg {
    height: ${rem("37px")};
    margin: ${rem("43px")} auto ${rem("0px")};
  }
`;

const CardText = styled.div`
  text-align: center;
  max-width: ${rem("220px")};
  font-size: ${rem("14px")};
  font-weight: 400;
  line-height: ${rem("24px")};
  color: #666666;
  margin: ${rem("20px")} auto ${rem("0px")};
`;

const Disclaimer = styled.div`
  max-width: ${rem("674px")};
  font-size: ${rem("12px")};
  line-height: ${rem("20px")};
  text-align: center;
  color: #666666;
  margin: ${rem("19px")} auto ${rem("0px")};

  > a {
    text-decoration: underline;
    color: #666666;

    &:hover {
      color: #666666;
    }
  }
  ${({ darkMode }) =>
    darkMode === "true" &&
    css`
      color: #d5d5d5;

      > a {
        text-decoration: underline;
        color: #ffffff;

        &:hover {
          color: #ffffff;
        }
      }
    `}
`;

const CashForward = ({
  widgetIdentifier,
  maxCashback,
  coloredTiles,
  primaryColor,
  darkMode,
}) => {
  return (
    <div>
      <Banner
        backgroundImg={
          widgetIdentifier === "mondrianparkavenue"
            ? rewardsOverviewText.cashForwardSection.bannerImgMondrian
            : widgetIdentifier.includes("yotel")
            ? rewardsOverviewText.cashForwardSection.bannerImgYotel
            : rewardsOverviewText.cashForwardSection.bannerImg
        }
        title={`${maxCashback}% ${rewardsOverviewText.cashForwardSection.title}`}
        subtitle={rewardsOverviewText.nonInstayCards[2].description}
        coloredTiles={coloredTiles}
        primaryColor={primaryColor}
      />
      <CardContainer>
        <Card>
          <MapMarker />
          <CardText>
            {rewardsOverviewText.cashForwardSection.card1.text}
          </CardText>
        </Card>
        <Card>
          <PiggyBank />
          <CardText>
            {rewardsOverviewText.cashForwardSection.card2.text}
          </CardText>
        </Card>
        <Card>
          <Hotel />
          <CardText>
            {rewardsOverviewText.cashForwardSection.card3.text}
          </CardText>
        </Card>
      </CardContainer>
      <Disclaimer darkMode={darkMode}>
        {rewardsOverviewText.cashForwardSection.dislaimer}{" "}
        <a href="https://theguestbook.com/faq#Cash-forward" target="_blank">
          {rewardsOverviewText.learnMore}.
        </a>
      </Disclaimer>
      <Line />
      <Footer widgetIdentifier={widgetIdentifier} darkMode={darkMode} />
    </div>
  );
};

CashForward.propTypes = {
  widgetIdentifier: PropTypes.string.isRequired,
  maxCashback: PropTypes.number.isRequired,
  coloredTiles: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  primaryColor: PropTypes.string.isRequired,
  darkMode: PropTypes.string.isRequired,
};

export default CashForward;
